var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{staticClass:"btn navbar-btn btn-signin",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_vm._v("Logga in")])])
}
var staticRenderFns = []

export { render, staticRenderFns }